import React, { Component } from 'react';
import { connect } from "react-redux";
import { openPullout } from "../../Actions/endUserActions"

import axios from "axios";
import { Trans } from 'react-i18next';
import { useLazyQuery } from '@apollo/client';
import { GET_BOOKING_BY_SOURCE_ID } from '../../GraphQL/Queries/bookings';

//A React component will allow us to quickly iterate and change our code. It provides 
const EUBookingCard = ({ booking, ...props }) => {
    const [getBookingQuery, { loading: loadingBooking }] = useLazyQuery(GET_BOOKING_BY_SOURCE_ID, {
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
    });

    const openBookingPullout = async () => {
        try {
            const { data: { getBookingBySourceBookingId } } = await getBookingQuery({ variables: { sourceBookingId: +booking.BOOK_ID } })
            props.dispatch(openPullout({
                ...booking,
                extendedProps: {
                    booking: getBookingBySourceBookingId
                }
            }))
        } catch (error) {
            console.log("Something went wrong");
        }
    }

    return (
        <div className="columns large-4 medium-6 small-12 end">
            <div className="card eu-booking-card">
                <div className="eu-booking-vehicle-image">
                    <img src={props.img} />
                </div>
                <div className="card-section eu-booking-info">
                    <div className="veh-name">
                        <div className="row collapse">
                            <div className="eu-booking-card-vehicle-name columns large-6 medium-6 small-6">
                                {props.year} <span className="semibold">{props.make} {props.model} {props.trim}</span>
                            </div>
                        </div>
                        <hr />
                    </div>
                    <div className="eu-booking-card-datetime row collapse">
                        <div className="eu-booking-card-pickup columns large-5 medium-5 small-5 float-left pickup">
                            <div className="eu-booking-card-date">{props.pickupdate}</div>
                            <div className="eu-booking-card-time black-lighter">{props.pickuptime}</div>
                        </div>
                        <div className="columns large-2 medium-2 small-2">
                        </div>
                        <div className="eu-booking-card-dropoff columns large-5 medium-5 small-5 float-right align-right">
                            <div className="eu-booking-card-date">{props.dropoffdate}</div>
                            <div className="eu-booking-card-time black-lighter">{props.dropofftime}</div>
                        </div>
                    </div>
                    <a className="button primary w-100 mt-12" style={{ cursor: "pointer" }} onClick={openBookingPullout}><Trans>See Booking Details</Trans></a>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = store => ({
    userSession: store.userSession
});

export default connect(mapStateToProps)(EUBookingCard);